import { StrictRouteConfig } from "@/router/router";

export const teamRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/teams",
        name: "teams",
        component: () => import(/* webpackChunkName: "team" */ "@/views/users/teams.vue"),
        meta: {
            requiresAuth: true,
            label: "Teams",
            title: "Manage teams",
            includeInNavigation: true,
            icon: "account-group-outline",
            matchExact: true,
            path: ["dashboard", "teams"],
            order: 50,
        },
    },
    {
        path: "/customers/:customerId/teams/:teamId",
        name: "team",
        component: () => import(/* webpackChunkName: "team" */ "@/views/users/team.vue"),
        meta: {
            requiresAuth: true,
            label: "Teams",
            title: "Manage teams",
            icon: "account-group-outline",
            matchExact: true,
            path: ["dashboard", "teams", "team"],
        },
    },
];
